import React, { useMemo, useState } from 'react';
import ToolLayout from './layout/ToolLayout';
import Card, { CardHeader } from './ui/Card';
import Button from './ui/Button';
import CopyButton from './ui/CopyButton';
import FeedbackMessage from './ui/FeedbackMessage';
import FormField from './ui/FormField';

const StringUtilities = () => {
  const [inputText, setInputText] = useState('');
  const [outputText, setOutputText] = useState('');
  const [substring, setSubstring] = useState('');
  const [splitSeparator, setSplitSeparator] = useState(' ');
  const [feedback, setFeedback] = useState('');

  const stats = useMemo(() => ({
    charCount: inputText.length,
    wordCount: inputText.trim() ? inputText.trim().split(/\s+/).length : 0,
    lineCount: inputText ? inputText.split(/\r\n|\r|\n/).filter(Boolean).length : 0,
  }), [inputText]);

  const applyTransformation = (operation) => {
    const handlers = {
      uppercase: () => inputText.toUpperCase(),
      lowercase: () => inputText.toLowerCase(),
      reverse: () => inputText.split('').reverse().join(''),
      capitalize: () => inputText.replace(/\b\w/g, (char) => char.toUpperCase()),
      split: () => inputText.split(splitSeparator).join('\n'),
    };

    const nextValue = handlers[operation]?.() ?? inputText;
    setOutputText(nextValue);
    setFeedback('Transformação executada com sucesso.');
  };

  const checkContains = () => {
    if (!substring) {
      setFeedback('Informe um trecho para verificar ocorrência.');
      return;
    }

    const contains = inputText.toLowerCase().includes(substring.toLowerCase());
    setOutputText(contains ? `O texto contém "${substring}".` : `O texto não contém "${substring}".`);
    setFeedback(contains ? 'Ocorrência encontrada.' : 'Nenhuma ocorrência encontrada.');
  };

  return (
    <ToolLayout
      title="Text Manipulator"
      description="Transforme, normalize e inspecione textos rapidamente em uma interface consistente."
      category="Text & Formatting"
      note="Operações locais"
    >
      <div className="tool-grid tool-grid--tool-page">
        <Card>
          <CardHeader title="Entrada" description="Cole o texto e aplique as operações mais comuns." />
          <FormField label="Texto">
            <textarea className="app-textarea" rows="10" value={inputText} onChange={(e) => setInputText(e.target.value)} placeholder="Cole ou digite seu texto aqui" />
          </FormField>
          <div className="inline-fields">
            <FormField label="Buscar trecho">
              <input className="app-input" type="text" value={substring} onChange={(e) => setSubstring(e.target.value)} placeholder="substring" />
            </FormField>
            <FormField label="Separador para split">
              <input className="app-input" type="text" value={splitSeparator} onChange={(e) => setSplitSeparator(e.target.value)} placeholder="espaço, vírgula, ; ..." />
            </FormField>
          </div>
          <div className="tool-actions tool-actions--wrap">
            <Button onClick={() => applyTransformation('uppercase')}>Uppercase</Button>
            <Button variant="secondary" onClick={() => applyTransformation('lowercase')}>Lowercase</Button>
            <Button variant="secondary" onClick={() => applyTransformation('reverse')}>Reverse</Button>
            <Button variant="secondary" onClick={() => applyTransformation('capitalize')}>Capitalize</Button>
            <Button variant="secondary" onClick={() => applyTransformation('split')}>Split</Button>
            <Button variant="ghost" onClick={checkContains}>Contains</Button>
          </div>
          <FeedbackMessage type="info">{feedback}</FeedbackMessage>
        </Card>

        <Card>
          <CardHeader title="Saída" description="Resultado e métricas rápidas do texto." action={<CopyButton value={outputText} />} />
          <div className="stats-grid">
            <div><strong>{stats.charCount}</strong><span>caracteres</span></div>
            <div><strong>{stats.wordCount}</strong><span>palavras</span></div>
            <div><strong>{stats.lineCount}</strong><span>linhas</span></div>
          </div>
          <div className="output-panel">
            <span className="output-panel__label">Resultado</span>
            <pre>{outputText || 'O resultado das transformações aparecerá aqui.'}</pre>
          </div>
        </Card>
      </div>
    </ToolLayout>
  );
};

export default StringUtilities;
